import { looksLikeQuestion, matchOmniboxActions, OmniboxAction } from './omnibox-actions'

export type OmniboxPatient = {
  id: string
  fullName: string
  birthday?: string
}

export type OmniboxPatientSearch = {
  patients: OmniboxPatient[]
  /** Includes the debounce delay and the request for the current input. */
  isSearching: boolean
}

export type OmniboxOption =
  | { kind: 'action'; action: OmniboxAction }
  | { kind: 'patient'; patient: OmniboxPatient }
  | { kind: 'elara'; query: string; attachmentCount?: number }

/**
 * Orders results and prevents an unresolved patient lookup from falling back to Elara.
 * Attached files can only go to Elara, so they make "Ask Elara" the single option (even with no text).
 */
export function buildOmniboxOptions(
  input: string,
  actions: OmniboxAction[],
  { patients, isSearching }: OmniboxPatientSearch,
  canAskElara: boolean,
  attachmentCount = 0
): OmniboxOption[] {
  const query: string = input.trim()
  if (attachmentCount > 0) return canAskElara ? [{ kind: 'elara', query, attachmentCount }] : []
  if (!query) return []
  const results: OmniboxOption[] = [
    ...matchOmniboxActions(query, actions).map((action): OmniboxOption => ({ kind: 'action', action })),
    ...patients.map((patient): OmniboxOption => ({ kind: 'patient', patient })),
  ]
  if (!canAskElara || (isSearching && results.length === 0)) return results
  const elara: OmniboxOption = { kind: 'elara', query }
  return looksLikeQuestion(query) || results.length === 0 ? [elara, ...results] : [...results, elara]
}
